export default __webpack_public_path__ + "static/media/Sylphlike Sash.6c0910a4.jpg";